import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import { ASSIGNED_EMPLOYEES_STATUS_FILTER } from '../types';
import type { AssignedEmployeesStatusFilter } from '../types';


export interface AssignedEmployeesExportFilters {
  status?: AssignedEmployeesStatusFilter;
}

export class AssignedEmployeesExportService {
  async export(
    filters?: AssignedEmployeesExportFilters,
  ): Promise<ApiResponse<{ blob: Blob; filename: string }>> {
    const isAllStatuses = filters?.status === ASSIGNED_EMPLOYEES_STATUS_FILTER.ALL;
    const queryString = buildQueryString({
      status: isAllStatuses ? undefined : filters?.status,
    });
    const endpoint = `${API_CONFIG.ENDPOINTS.SECURITY_GROUPING.ASSIGNED_EMPLOYEES_FILE}${queryString}`;

    return apiClient.downloadBlobWithFilename(endpoint, { method: 'GET' });
  }
}

export const assignedEmployeesExportService = new AssignedEmployeesExportService();
